<template>
  <div class="page">
    <div class="n_height"></div>
    <!-- v-if="isNone && follow_url != ''" -->
    <div class="follow_wx" v-if="isNone && follow_thumb != ''">
      <div class="zn_fl">
        <span class="fl iconfont iconcuohao2" @click="isNone = false"></span>
        <p class="fl">
          关注公众号
          <b>享更多优惠信息</b>
        </p>
      </div>
      <div class="zn_fr" @click="goAttentFg">去关注</div>
    </div>

    <!--  banner 区域  -->
    <div class="banner zn_banner_index">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          v-for="(item, index) in myInfo.banner_list"
          :key="index"
          @click="goBannerDetails(item)"
        >
          <van-image fit="fill" :src="item.banner_pic" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!--金刚区-->
    <div class="widthBox">
      <van-swipe indicator-color="white">
        <van-swipe-item v-for="(item,index) in myInfo.brands_list" :key="index">
          <div class="kong">
            <div
              class="kong_list"
              @click="tiaozhuanFg(index,tindex)"
              v-for="(titem,tindex) in item"
              :key="tindex"
              :data-item="titem"
            >
              <div class="img">
                <img :src="titem.logo" />
              </div>
              <div class="text">{{titem.name}}</div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- <div class="kong">
      <div
        class="kong_list"
        @click="$refs.scrollTo.scrollTo(index)"
        v-for="(item,index) in myInfo.brands_list"
        :key="index"
        :data-item="item"
      >
        <div class="img">
          <img :src="item.logo" />
        </div>
        <div class="text">{{item.name}}</div>
      </div>
    </div>-->
    <!--     爆款区   -->
    <div
      class="HotMoney"
      v-if="myInfo.adv_one && myInfo.adv_one.banner_pic"
      @click="goBannerDetails(myInfo.adv_one)"
    >
      <div class="right">
        <img class="imges" :src="myInfo.adv_one.banner_pic" />
      </div>
    </div>
    <div
      class="HotMoney"
      v-if="myInfo.adv_two && myInfo.adv_two.banner_pic"
      @click="goBannerDetails(myInfo.adv_two)"
    >
      <div class="right">
        <img class="imges" :src="myInfo.adv_two.banner_pic" />
      </div>
    </div>
    <!--        特价专区-->
    <!-- v-if="activityList.activity_id" -->
    <div class="SpecialOffer" v-if="activityList.activity_id">
      <div class="title">
        <div class="h3">特价专区</div>
        <div class="more_test" @click="jump('/shopList')">
          更多商品
          <span class="iconfont iconarrow-right-bold"></span>
        </div>
      </div>
      <div class="content swiper_goods">
        <div
          class="list"
          v-for=" (item,index) in activityList.goods_list"
          :key="index"
          @click="goActDetails(item.id)"
        >
          <div class="img yj_n_img">
            <img :src="item.images?item.images:imgPath+'yj_defatult.png'" alt />
          </div>
          <div class="n_nowarp">{{item.goods_name}}</div>
          <div class="pic">
            <i class="yj_tag">￥</i>
            {{item.activity_price}}
          </div>
          <del class="market_price">￥{{item.market_price}}</del>
        </div>
      </div>
    </div>

    <div class="n_gifBag" @click="jump('/giftBig')">
      <img :src="imgPath + 'yj_jskgl.png'" alt />
    </div>
    <!--        商品选择区域-->
    <div class="ProductList" v-if="browse == true">
      <div class="tabList">
        <van-tabs
          background="#AB1515"
          @click="addevebt"
          ref="scrollTo"
          title-inactive-color="#FFFFFF"
          title-active-color="#E9D694"
          scrollspy
          sticky
          color="#E9D694"
        >
          <van-tab
            v-model="active"
            v-for="(item) in myInfo.brands_goods_list"
            :title="item.name"
            :key="item.id"
          >
            <div class="details">
              <div class="h3">{{item.name}}</div>
              <div class="content">
                <div class="img" @click="openVideoFg(item)">
                  <img :src="item.img_url?item.img_url:imgPath+'yj_defatult.png'" />
                </div>
                <div class="content-h2">{{item.name}}</div>
                <div class="content-title">{{item.describe}}</div>

                <div
                  v-if="item.goods_list"
                  :class="(item.goods_list.length==1?'ProductList_list list_one':item.goods_list.length==2?'ProductList_list list_two':'ProductList_list')"
                >
                  <div
                    style="overflow: scroll;display: flex;justify-content: space-between;min-width:100%"
                  >
                    <div
                      class="list goods_revo"
                      v-for="(item_two,index) in item.goods_list"
                      :key="index"
                      @click="goBannerDetails({...item_two, goods_id: item_two.id, page_type: 'goods_detail'})"
                    >
                      <img
                        class="list_goods_img"
                        fit="fill"
                        :src="item_two.images?item_two.images:imgPath+'yj_defatult.png'"
                      />
                      <div class="title">{{item_two.goods_name}}</div>
                      <div class="pic">
                        <span>¥</span>
                        {{item_two.price}}
                      </div>
                      <div class="yj_n_price_del just_space">
                        <span class="pco">￥{{item_two.market_price}}</span>
                        <p v-if="item.goods_list.length<=2" class="n_textmore">销量:{{item_two.sales}}</p>
                      </div>
                      <div class="n_namepad" v-if="item.goods_list.length>=3">销量:{{item_two.sales}}</div>
                      <img
                        class="suit_img"
                        :src="imgPath + 'yj_t_taocan1.png'"
                        alt
                        v-if="item_two.is_package_goods == 1 && item_two.goods_activity_batch_details_id == ''"
                      />
                      <img
                        class="suit_img"
                        :src="imgPath + 'yj_t_taoca.png'"
                        alt
                        v-if="item_two.is_mz_goods == 1 && item_two.goods_activity_batch_details_id == ''"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div v-if="browse == false" ref="scrollTo">
      <van-sticky>
        <div class="search_data">
          <div class="search_item" @click="sortFg()">
            <span class="text">综合</span>
          </div>
          <div class="search_item" @click="sortFg('sales',order.sales)">
            <span class="text">销量</span>
            <div class="item_fh">
              <span :class="['iconfont', 'iconup_9',order.sales == 'asc'   ? 'active_color' : '']"></span>
              <span
                :class="['iconfont', 'icondown_9',order.sales == 'desc'   ? 'active_color' : '']"
              ></span>
            </div>
          </div>
          <div class="search_item" @click="sortFg('price',order.price)">
            <span class="text">价格</span>
            <div class="item_fh">
              <span :class="['iconfont', 'iconup_9',order.price == 'asc' ? 'active_color' : '']"></span>
              <span
                :class="['iconfont', 'icondown_9',order.price == 'desc'  ? 'active_color' : '']"
              ></span>
            </div>
          </div>
        </div>
      </van-sticky>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="goods_details">
          <div
            class="goods_detail"
            v-for="goodsItem in goodsList"
            :key="goodsItem.id"
            @click="goBannerDetails({...goodsItem,goods_id: goodsItem.id,page_type: 'goods_detail'})"
          >
            <img class="goods-img" :src="goodsItem.images" alt />
            <div class="goods_footer">
              <div class="goods_title">{{goodsItem.goods_name}}</div>
              <div class="goods_price">
                <span>￥</span>
                <span class="goods_fg">{{goodsItem.price}}</span>
              </div>
              <div class="flex">
                <p class="n_dele">￥{{goodsItem.market_price}}</p>
                <p>销量：{{goodsItem.sales}}</p>
              </div>
            </div>
            <img
              class="suit_img"
              :src="imgPath + 'yj_t_taocan1.png'"
              alt
              v-if="goodsItem.is_package_goods == 1 && goodsItem.goods_activity_batch_details_id == ''"
            />
            <img
              class="suit_img"
              :src="imgPath + 'yj_t_taoca.png'"
              alt
              v-if="goodsItem.is_mz_goods == 1 && goodsItem.goods_activity_batch_details_id == ''"
            />
          </div>
        </div>
      </van-list>
    </div>
    <div class="bottom"></div>
    <!--    右侧操作icon-->
    <div class="right_icons">
      <!--      暂时隐藏客服-->
      <!-- style="display: none" -->
      <div>
        <!-- <img :src="imgPath+'yj_icon_kefu.png'" alt @click="isPoster = true" /> -->
        <img :src="imgPath+'yj_tbfenxaing.png'" alt @click="showShare = true" />
      </div>
      <div class="content_wai">
        <p @click="browseFg" class="contnet_brow">
          <span class="checkSelect">{{ browse == 1 ? '简易' : '品牌'}}</span>
          <span class="checkcolor">浏览</span>
        </p>
      </div>
      <div>
        <img
          class="n_huitop"
          :src="imgPath+'yj_icon_gouwuche.png'"
          alt
          @click="jump('/shoppingCart')"
        />
      </div>
      <div>
        <p v-if="isCmod"></p>
        <img class="n_huitop" :src="imgPath+'yj_icon_dibgbu.png'" alt @click.stop="toTop" />
      </div>
    </div>
    <van-overlay :show="isShow" @click="clearIsShowFg">
      <div class="wrapper" @click.stop>
        <video
          width="90%"
          height="100%"
          controls
          class="n_margtop"
          v-if="videos"
          :poster="videoImg"
        >
          <source :src="videos" type="video/mp4" v-if="videos != ''" />
          <!-- <source :src="videos" type="video/ogg" />您的浏览器不支持Video标签。 -->
        </video>
      </div>
    </van-overlay>
    <van-overlay :show="isQrcode" @click="isQrcode = false">
      <div class="n_warp" @click.stop>
        <img :src="follow_thumb" alt />
        <p>长按识别二维码,关注公众号</p>
      </div>
    </van-overlay>
    <div class="content_container">
      <vue-canvas-poster :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      <van-overlay :show="isPoster" @click="isPoster = false">
        <div class="wrapper_n" @click.stop>
          <div class="share-img">
            <img class="n_canvas" :src="posterImg" alt="分享图片" />
            <p class="n_save">长按保存到本地</p>
          </div>
        </div>
      </van-overlay>
    </div>
    <!-- 分享提示 -->
    <van-overlay :show="isTips" @click="isTips = false">
      <div class="wrapper_m" @click.stop>
        <img :src="imgPath + 'yj_share.png'" alt />
        <img @click="isTips = false" class="n_shareBtn" :src="imgPath + 'byj_utton.png'" alt />
      </div>
    </van-overlay>
    <van-share-sheet v-model="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
    <!-- 领取红包 -->
    <van-overlay :show="isRedCard" @click="isRedCard = false">
      <div class="red_card" @click.stop>
        <div class="flex red_end">
          <p></p>
          <img :src="imgPath + 'yijiu_dfs.png'" alt />
        </div>
        <div class="red_welcome">恭喜您获得</div>
        <div class="red_limit">{{redCardInfo.price}}</div>
        <div class="red_tips">数量有限，快来领取吧</div>
        <div class="user_img">
          <img :src="userInfo.avatar" alt />
        </div>
        <div class="red_text">恭喜你被红包砸中</div>
        <div class="red_btn">点击开启红包</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { analysisUrl } from '../../public/public.js'
import share from '../../public/share.js'
import wx from 'weixin-js-sdk'

let timer = null //定义初始值
export default {
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 100,
    },
  },
  name: 'index',
  components: {},
  data() {
    return {
      isRedCard: false,
      myInfo: {}, //数据
      SpecialOffer: [1, 2, 3],
      active: true,
      loading: false,
      finished: false,
      refreshing: false,
      activityList: {},
      isCmod: false, //禁止top
      show: false,
      isNone: true,
      isShow: false,
      videos: '',
      videoImg: '',
      follow_thumb: '',
      isQrcode: false,
      isPoster: false,
      painting: {},
      posterImg: '', //生成的海报
      isTips: false,
      showShare: false,
      options: [
        { name: '微信', icon: 'wechat' },
        { name: '分享海报', icon: 'poster' },
      ],
      goodsList: [],
      isGoodsList: false,
      finished: false,
      loading: false,
      order: {
        sales: '',
        price: '',
      },
      page: 0,
      browse: 1,
      redCardInfo: {},
    }
  },
  watch: {
    // '$store.state.shareStr': function (e) {
    //   if (e == 'home') {
    //     this.shareModelFg()
    //   }
    // },
  },
  mounted() {
    let urk = analysisUrl(window.location.href)
    this.$router.replace({ path: 'homeIndex', query: { ...urk } })
    return
    this.mallIndex()
  },
  created() {
    return
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.$store.commit('activeFailure', 0)
    let uid
    if (localStorage.getItem('userInfo')) {
      uid = JSON.parse(localStorage.getItem('userInfo')).id
    } else {
      uid = ''
    }
    this.poriteFg()
  },
  activated() {
    return
    this.$router.replace({ path: 'homeIndex' })
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (this.$store.state.shareStr != 'home') {
      new share(
        {
          startUrl: window.location.href,
        },
        this.$store,
        'home'
      )
    } else {
      this.shareModelFg()
    }
    this.follow_thumb = localStorage.getItem('follow_thumb')
    if (localStorage.getItem('userInfo')) {
      this.isNone =
        JSON.parse(localStorage.getItem('userInfo')).subscribe == 0
          ? true
          : false
    }
    this.$store.commit('acvityviFg', 0)
    this.getUrl()
    this.poriteFg()
  },
  methods: {
    //浏览模式
    browseFg() {
      // this.toTop()
      this.browse = !this.browse
      console.log(this.browse)
      if (this.browse == 0) {
      } else {
        this.page = 0
        this.goodsList = []
        this.onLoad()
      }
    },
    sortFg(type, orid) {
      orid == 'desc'
        ? (this.order = {
            [type]: 'asc',
          })
        : (this.order = {
            [type]: 'desc',
          })
      if (!type) {
        this.order = {
          sales: '',
          price: '',
        }
      }
      this.isGoodsList = true
      this.page = 0
      this.onLoad()
    },
    onLoad() {
      this.page++
      this.getGoodsList()
    },
    getGoodsList() {
      this.http('ClientGoods.simpleGoodsList', {
        page: this.page,
        limit: 20,
        order: this.order,
      }).then((res) => {
        if (this.isGoodsList) {
          this.goodsList = res.content.list
        } else {
          this.goodsList = this.goodsList.concat(res.content.list)
        }
        console.log(res.content.list[0])
        this.isGoodsList = false
        this.loading = false
        this.finished = this.goodsList.length == res.content.count
      })
    },
    onSelect(option) {
      if (option.icon == 'wechat') {
        this.isTips = true
        this.showShare = false
      } else {
        this.isPoster = true
        this.showShare = false
      }
    },
    //成功生成海报
    success(src) {
      this.posterImg = src
      // console.log(src)
    },
    fail(err) {
      console.log(err)
    },
    poriteFg() {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?type=share' +
        '&uid=' +
        uid +
        '&scenes=mall'
      this.painting = {
        width: '596px',
        height: '800px',
        borderRadius: '40px',
        background:
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/yj_home_hiabao.png',
        views: [
          {
            type: 'image',
            url: this.userInfo.avatar,
            css: {
              bottom: '240px',
              left: '36px',
              borderRadius: '40px',
              width: '80px',
              height: '80px',
            },
          },
          {
            type: 'text',
            text: this.userInfo.nick_name,
            css: {
              bottom: '290px',
              left: '136px',
              width: '360px',
              maxLines: 1,
              fontSize: '26px',
            },
          },
          {
            type: 'text',
            text: '为你推荐了一个名酒商城，快来看看吧',
            css: {
              bottom: '220px',
              left: '130px',
              width: '360px',
              maxLines: 2,
              fontSize: '26px',
              lineHeight: '30px',
            },
          },
          {
            type: 'text',
            text: '长按识别二维码',
            css: {
              bottom: '20px',
              left: '190px',
              width: '360px',
              maxLines: 2,
              fontSize: '26px',
              lineHeight: '30px',
            },
          },
          {
            type: 'qrcode',
            content: url,
            css: {
              bottom: '80px',
              left: '240px',
              color: '#000',
              width: '130px',
              height: '130px',
              borderWidth: '10px',
              borderColor: '#fff',
            },
          },
        ],
      }
    },
    shareModelFg() {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?type=share' +
        '&uid=' +
        uid +
        '&scenes=mall'
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })
      let shareInfo = {
        title: '壹玖叮咚_十大酒水一站购',
        desc: '我发现了一个名酒商城，快来看看吧~~',
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
        imgUrl:
          'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yi_logo.jpg',
      }
      wx.onMenuShareAppMessage(shareInfo)
      wx.onMenuShareTimeline(shareInfo)
    },
    //
    tiaozhuanFg(index, tindex) {
      console.log(index, tindex)
      let start
      if (index >= 1) {
        start = index * 10
      }
      let inx = index <= 0 ? tindex : start + tindex
      console.log(inx)
      this.$refs.scrollTo.scrollTo(inx)
    },

    openVideoFg(item) {
      this.videos = ''
      console.log(item)
      if (item.video) {
        this.$nextTick(() => {
          this.videos = item.video
          this.videoImg = item.img_url
        })
        this.isShow = true
      }
    },
    clearIsShowFg() {
      this.videos = ''
      this.isShow = false
    },
    getUrl() {
      let urk = analysisUrl(window.location.href)
      localStorage.setItem('shareInfo', JSON.stringify(urk))
      if (urk.type == 'share' && !JSON.parse(localStorage.getItem('isToken'))) {
        this.$store.commit('LoginFailure', true)
      }
      if (urk.type == 'share' && JSON.parse(localStorage.getItem('isToken'))) {
        this.shareExtensionFg(urk)
      } else if (JSON.parse(localStorage.getItem('shareInfo')).uid) {
        this.shareExtensionFg(JSON.parse(localStorage.getItem('shareInfo')))
      }
    },
    goAttentFg() {
      this.isQrcode = true
      // let info = JSON.parse(localStorage.getItem('userInfo'))
      // info.subscribe = 1
      // localStorage.setItem('userInfo', JSON.stringify(info))
      // window.location.href = this.follow_thumb
      // 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1MTA2MTI5OQ==&scene=117#wechat_redirect'
    },
    //分享关系
    async shareExtensionFg(obj) {
      let res = await this.http('Client.shareExtension', {
        share_member_id: obj.uid,
        share_staff_id: obj.share_staff_id || 0,
        scenes: obj.scenes,
      })
      localStorage.setItem('shareId', res.content.share_sign_no)
      if (res.content.share_sign_no) {
        this.getEffReceivePacket(res.content.share_sign_no)
      }
      console.log(res)
    },
    mallIndex() {
      //获取首页数据
      this.http('WebIndex.mallIndex', {}).then((res) => {
        if (res.status == 200) {
          this.myInfo = res.content
          this.activityList = res.content.activity
          console.log(res.content.activity)
          localStorage.setItem('activity_id', res.content.activity.activity_id)
          localStorage.setItem('batches_id', res.content.activity.batches_id)
        }
      })
    },
    addevebt(ev) {
      console.log(ev)
    },
    onClickLeft() {
      Toast('返回')
    },
    onClickRight() {
      Toast('按钮')
    },

    //跳转商品详情
    goBannerDetails(item) {
      console.log(item)
      if (item.goods_activity_batch_details_id) {
        this.goActDetails(item.goods_activity_batch_details_id)
      } else if (item.page_type == 'goods_detail') {
        this.$router.push({
          path: '/shopDetails',
          query: { goods_id: item.goods_id },
        })
      } else {
        window.location.href = item.url
      }
    },
    // 特价商品详情
    goActDetails(id) {
      console.log(id)
      this.$router.push({
        path: '/activeShopDetail',
        query: { goods_id: id, isActGoods: 'isAct' },
      })
    },
    toTop() {
      if (this.isCmod) return
      this.isCmod = true
      setTimeout(() => {
        this.isCmod = false
      }, 3000)
      // 动画
      timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
    //跳转路径
    jump(url) {
      // alert(url)
      this.$router.push({ path: url })
    },
    getEffReceivePacket(id) {
      this.http('MemberRedPacket.getEffReceivePacket', {
        share_sign_no: id,
      }).then((e) => {
        console.log(e)
        if (e.content.id) {
          this.isRedCard = true
          this.redCardInfo = e.content
        }
      })
    },
    // goGiftBig(){
    //   alert(1111)
    //   this.$router.push({
    //     path: '/giftBig',
    //   })
    // }
  },
}
</script>

<style scoped>
.n_warp {
  margin: 0 auto;
  text-align: center;
  transform: translate(0, 50%);
}
.n_warp img {
  display: block;
  width: 400px;
  height: 400px;
  margin: 0 auto;
}
.n_warp p {
  color: #fff;
  padding-top: 20px;
}
/*关注公众号*/
.follow_wx {
  /*width: 710px;*/
  margin: 0 20px 20px;
  height: 88px;
  line-height: 88px;
  background: #212226;
  border-radius: 50px;
  display: flex;
  color: #fff;
  font-size: 28px;
  justify-content: space-between;
}
.follow_wx .zn_fl {
  padding-left: 20px;
}
.follow_wx .zn_fl p {
  height: 88px;
  padding-left: 20px;
  line-height: 88px !important;
}
.follow_wx .zn_fr {
  background: #b84036;
  width: 180px;
  text-align: center;
  border-radius: 0 50px 50px 0;
}
.market_price {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: -4px;
  float: left;
}

.yj_n_img,
.yj_n_img img {
  width: 200px;
  height: 200px;
  border-radius: 10px;
}
.yj_n_price {
  font-size: 30px !important;
}
.yj_n_price span {
  font-size: 24px !important;
}
.yj_n_price_del {
  font-size: 26px !important;
}
.yj_tag {
  font-size: 24px;
}
.right_icons {
  position: fixed;
  bottom: 600px;
  right: 30px;
  width: 80px;
  height: 80px;
}
.right_icons div {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
  position: relative;
  top: 120px;
  left: 0;
}
.right_icons div p {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0);
}
.right_icons div img {
  width: 80px;
  height: 80px;
}
</style>
<style scoped lang="scss">
.n_huitop {
  width: 81px;
  height: 82px;
}
.wrapper {
  transform: translate(0, 50%);
  text-align: center;
}
// .n_margtop {
//   // transform: translate(0, 50%);
//   // margin-top: 400px;
// }
.n_namepad {
  padding: 5px;
  font-size: 26px;
}
.n_cardprice {
  display: flex;
  align-items: center;
  font-size: 42px;
}
.nm_juspace {
  justify-content: space-between;
}
.n_yuan {
  font-size: 32px;
}
.n_button {
  width: 500px;
  height: 88px;
  line-height: 88px;
  background: #ee0a24;
  border-radius: 44px;
  color: rgba(255, 255, 255, 1);
  font-size: 30px;
  text-align: center;
  margin-top: 30px;
}
.n_tihuo {
  width: 500px;
  height: 274px;
  padding: 20px;
  box-sizing: border-box;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_th_card.png')
    no-repeat left top;
  background-size: 500px 274px;
  color: rgba(214, 176, 151, 1);
}
.n_footertxt {
  margin-top: 80px;
  font-size: 24px;
  color: #e7c5af;
}
.n_photo {
  width: 560px;
  // height: 353px;
  background: #ffffff;
  border-radius: 20px;
  margin: 400px auto;
  box-sizing: border-box;
  padding: 38px 30px;
}
.n_input {
  width: 100%;
  padding: 28px 30px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #dedede;
  box-sizing: border-box;
}
.n_canbtn {
  color: rgba(238, 10, 36, 1);
  background: #ffffff;
  margin-left: 40px;
}
.n_tipsCont {
  font-size: 26px;
  color: #ee0a24;
  margin-left: 30px;
  margin-top: 10px;
}
.page {
  //width: 750px;
  min-height: 100vh;
  background: #d90001;
}
//.my-swipe{
//  height: 100% !important;
//}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  //line-height: 320px;
  text-align: center;
  background-color: #39a9ed;

  img {
    width: auto;
    height: auto;
    //width: 710px;
    height: 100%;
  }
}

.banner {
  //width: 710px;
  //height: 320px;
  margin: 20px;
  overflow: hidden;
}

.kong {
  width: 710px;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  //width: 710px;
  height: 340px;
  margin: 0 0 20px 20px;
  /*padding: 33px 0 ;*/
  background: #ab1515;
  border-radius: 20px;

  .kong_list {
    width: 20%;
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffffff;

    .img {
      width: 90px;
      height: 90px;
      overflow: hidden;

      img {
        width: auto;
        height: auto;
        width: 90px;
        height: 90px;
        border-radius: 50%;
      }
    }

    .text {
      text-align: center;
      font-size: 24px;
      padding-top: 5px;
    }
  }
}

.widthBox {
  width: 750px;
  margin: 0 auto;
}

.HotMoney {
  display: flex;
  width: 690px;
  height: 300px;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 30px;
  color: #e9d694;
  border: 10px solid #e9d694;
  background: linear-gradient(90deg, #c73429 0%, #dd4623 99%);
  border-radius: 30px;

  .left {
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;

    .h2 {
      font-weight: 600;
      font-size: 32px;
      /*line-height: 30px;*/
    }

    .text {
      font-size: 19px;
      /*line-height: 10px;*/
    }

    .pic {
      width: 200px;
      height: 30px;
      padding: 5px;
      margin: 20px 0;
      border-radius: 14px;
      line-height: 30px;
      font-size: 32px;
      color: $indexColor;
      background: #e9d694;

      span {
        font-size: 24px;
      }

      .pic_staet {
        text-decoration: line-through;
      }
    }

    .button {
      width: 200px;
      height: 57px;
      line-height: 57px;
      border-radius: 4px;
      border: 1px solid #e9d694;
      text-align: center;
      margin-top: 10px;
    }
  }

  .right {
    width: 100%;
    position: relative;
    .imges {
      height: 100%;
      width: 100%;
    }
    .right_top {
      position: absolute;
      top: -20px;
      right: 0;
    }
  }
}
.swiper_goods {
  overflow: hidden;
  overflow-x: scroll;
  margin-right: 10px;
}
.SpecialOffer {
  width: 640px;
  height: 370px;
  color: #e9d694;
  border: 10px solid #e9d694;
  padding: 20px 25px 30px;
  background: linear-gradient(90deg, #c73429 0%, #dc4623 100%);
  border-radius: 30px;
  margin: 0px auto 20px;

  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .h3 {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #e9d694;
    }
    .text {
      font-size: 24px;
    }
  }
  .n_nowarp {
    font-size: 26px;
    padding-top: 20px;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*不换行*/
    text-overflow: ellipsis; /*超出部分文字以...显示*/
  }

  .content {
    width: 100%;
    display: flex;
    // justify-content: space-between;
    margin-top: 20px;

    .list {
      width: 200px;
      margin-right: 18px;
      .img {
        width: 200px;
        height: 200px;
        background: #ffffff;
        border-radius: 20px;
      }

      .title {
        width: 100%;
        height: 30px;
        margin-top: 15px;
        overflow: hidden;
        text-overflow: ellipsis; //超出显示省略号
        white-space: nowrap; //强制文本在一行内显示
      }

      .pic {
        text-align: left;
        overflow: hidden;
        text-decoration: inherit;
        white-space: nowrap;
        line-height: 38px;
        i {
          font-size: 24px;
        }
      }
    }
  }
}

.ProductList {
  width: 100%;
  margin-top: 20px;

  .tabList {
    display: flex;
    width: 100vw;
    overflow: hidden;

    .details {
      width: 100vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 20px;
      position: relative;

      .h3 {
        font-size: 46px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #e9d694;
        line-height: 126px;
        text-align: center;
      }

      .content {
        width: 710px;
        position: relative;
        padding-top: 400px;
        margin: 0 auto;
        background: #388188;
        border-radius: 20px;
        overflow: hidden;
        .img {
          width: 200%;
          height: 400px;
          border-radius: 0 0 50% 50%; // 这里是图片
          overflow: hidden;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -710px;
          img {
            width: 100vw;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -355px;
            height: 400px;
          }
        }

        .content-h2 {
          color: #ffffff;
          font-size: 46px;
          text-align: left;
          padding-left: 22px;
        }

        .ProductList {
          width: 100%;
          margin-top: 20px;

          .tabList {
            display: flex;
            width: 100vw;
            overflow: hidden;

            .details {
              width: 100vw;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .h3 {
                font-size: 46px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #e9d694;
                text-align: center;
                line-height: 126px;
              }

              .content {
                width: 710px;
                min-height: 860px;
                margin: 0 auto;
                background: #388188;
                border-radius: 20px;
                overflow: hidden;

                .img {
                  width: 100%;
                  height: 400px;
                  border-radius: 0 0 24% 24%; // 这里是图片
                  overflow: hidden;
                  img {
                    width: 100%;
                    height: 400px;
                  }
                }

                .content-h2 {
                  color: #ffffff;
                  font-size: 46px;
                  text-align: left;
                  padding-left: 22px;
                }
              }
            }

            .ProductList_list {
              padding: 0 22px;
              display: flex;
              justify-content: space-between;
              .list {
                width: 166px;
                // height: 274px;
                background: #ffffff;
                border-radius: 10px;
                margin-bottom: 22px;
                padding: 22px 0;
                text-align: left;

                .title {
                  font-size: 22px;
                  color: #333333;
                  margin: 5px 0;
                }
                .pic {
                  color: #cc1111;
                  font-size: 28px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.ProductList_list {
  padding: 0 22px;
  display: flex;
  justify-content: space-between;
  .list {
    width: 210px;
    // height: 330px;
    background: #fff;
    border-radius: 10px;
    margin-bottom: 22px;
    margin-right: 20px;
    padding-bottom: 10px;
    box-sizing: border-box;
    text-align: left;
    .title {
      font-size: 28px;
      color: #333333;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      font-weight: bold;
      margin: 5px 0 0;
      padding: 0 8px;
    }
    .list_goods_img {
      height: 210px;
      width: 210px;
      border-radius: 10px 10px 0 0;
    }

    .pic {
      padding: 0 8px;
      color: #cc1111;
      font-weight: bold;
      font-size: 28px;
    }
    .pco {
      padding: 0 8px;
      font-weight: bold;
      text-decoration: line-through;
      color: #999999;
      opacity: 0.6;
      font-size: 20px;
    }
  }
}
.content-title {
  color: #ffffff;
  font-size: 22px;
  text-align: left;
  padding-left: 22px;
  padding-bottom: 30px;
}
.content {
  .list_two {
    .list {
      width: 328px;
      // height: 518px;
      margin-right: 0px;
    }
    .list_goods_img {
      height: 328px;
      width: 328px;
      border-radius: 10px 10px 0 0;
    }
    .title {
      padding: 7px 10px;
      font-size: 34px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    .pic {
      font-size: 42px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #cc1111;
      span {
        font-size: 34px !important;
      }
    }
    .pco {
      font-size: 28px;
    }
  }
}
.content {
  .list_one {
    .list {
      width: 665px;
      padding: 25px 20px;
      padding-left: 208px;
      // height: 210px;
      position: relative;
      margin-right: 0px;
    }
    .list_goods_img {
      border-radius: 10px;
      height: 160px;
      width: 160px;
      position: absolute;
      top: 25px;
      left: 20px;
    }
    .title {
      padding: 7px 0;
      font-size: 34px;
    }
    .pic {
      font-size: 34px;
    }
    .pco {
      font-size: 26px;
    }
  }
}

.bottom {
  height: 280px;
}
.n_height {
  height: 20px;
}
.n_topsine {
  width: 710px;
  margin: 0 auto;
  background: #000;
  border-radius: 50px;
  color: rgba(255, 255, 255, 1);
  background: rgba(33, 34, 38, 1);
}
.n_lef {
  flex: 1;
  padding: 10px 15px;
  align-items: center;
}
.n_spacebeewt {
  justify-content: space-between;
  align-items: center;
}
.n_right {
  padding: 30px 60px;
  background: rgba(184, 64, 54, 1);
  font-size: 28px;
  border-radius: 0 40px 40px 0;
}
.iconcuohao2 {
  font-size: 44px;
}
.n_mragleft {
  margin-left: 30px;
}
.n_attention {
  font-size: 28px;
}
.n_message {
  font-size: 24px;
  padding-left: 7px;
}
.n_gifBag {
  height: 100%;
}
.n_gifBag img {
  width: 100%;
  height: 100%;
}
.just_space {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.n_textmore {
  text-decoration: none !important;
  padding: 0 5px;
  font-size: 26px;
}
.more_test {
  padding: 10px;
  font-size: 24px;
  padding-top: 5px;
}
.suit_img {
  position: absolute;
  top: 0;
  right: 0;
  width: 68px;
  height: 50px;
}
.goods_revo {
  position: relative;
}
.wrapper_n {
  width: 596px;
  height: 800px;
  margin: 200px auto 0;
}
.n_canvas {
  width: 596px;
  height: 800px;
}
.n_save {
  font-size: 36px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-top: 20px;
}
.wrapper_m img {
  width: 95%;
}
.n_shareBtn {
  display: block;
  width: 236px !important;
  margin: 400px auto 0;
}
.goods_details {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 24px;
  .goods_detail {
    width: 340px;
    background: #ffffff;
    margin-bottom: 20px;
    border-radius: 20px;
    position: relative;
    .goods-img {
      display: block;
      width: 340px;
      height: 340px;
      border-radius: 20px 20px 0 0;
    }
    .goods_footer {
      padding: 4px 16px 30px;
      .goods_title {
        height: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 28px;
        font-weight: bold;
        color: #333333;
      }
      .goods_price {
        font-size: 22px;
        font-weight: bold;
        color: #df0000;
        .goods_fg {
          font-size: 36px !important;
        }
      }
      .flex {
        justify-content: space-between;
        font-size: 22px;
        font-weight: bold;
        color: #999999;
        opacity: 0.67;
        .n_dele {
          text-decoration: line-through;
        }
      }
    }
  }
}
.search_data {
  display: flex;
  height: 100px;
  justify-content: space-between;
  padding: 0 52px;
  background: rgba(187, 0, 0, 1);
  .search_item {
    display: flex;
    align-items: center;
    margin-right: 32px;
    .text {
      font-size: 30px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .item_fh {
      margin-left: 10px;
      span {
        display: block;
        font-size: 24px;
        color: rgba(255, 255, 255, 1);
      }
      .active_color {
        color: rgba(250, 171, 12, 1) !important;
      }
    }
  }
}
.contnet_brow {
  width: 80px;
  height: 80px;
  background: #800e0e !important;
  border-radius: 50%;
  text-align: center;
  top: 6px !important;
  left: 2.5px !important;
}
.checkSelect {
  display: block;
  padding-top: 5px;
  color: rgba(233, 214, 148, 1);
  font-size: 24px;
}
.checkcolor {
  display: block;
  color: rgba(233, 214, 148, 1);
  font-size: 24px;
}
.content_wai {
  width: 90px !important;
  height: 90px !important;
  border-radius: 50%;
  background: #e9d694;
}
.red_card {
  width: 611px;
  height: 743px;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yijiu_openhb.png')
    no-repeat center;
  background-size: 100%;
  margin: 360px auto 0;
  padding: 46px 72px;
  box-sizing: border-box;
  .red_end {
    justify-content: space-between;
    img {
      width: 55px;
      height: 55px;
    }
  }
  .red_welcome {
    font-size: 32px;
    color: #ba6d5b;
    text-align: center;
  }
  .red_limit {
    font-size: 100px;
    font-weight: 600;
    color: #e82c22;
    text-align: center;
  }
  .red_tips {
    font-size: 26px;
    color: #ba6d5b;
    text-align: center;
    margin-top: 21px;
  }
  .user_img {
    width: 100px;
    height: 100px;
    margin: 80px auto 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .red_text {
    font-size: 30px;
    color: #ffffff;
    text-align: center;
  }
  .red_btn {
    padding: 23px 143px;
    font-size: 30px;
    color: #ffffff;
    background: #d8d8d8 linear-gradient(85deg, #f3c177 0%, #e89957 100%);
    border-radius: 44px;
    margin: 40px auto 0;
  }
}
</style>
